import { useDispatch } from 'react-redux';

import { useParams } from 'react-router';

import { useEffect, useState } from 'react';

import { Grid, Card, CardHeader, Typography, Divider, CardContent, TextField, FormControl, InputLabel, Select, MenuItem, Button, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Chip, CircularProgress, TableFooter, TablePagination, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, Tooltip, Checkbox, Box, FormControlLabel, FormLabel, RadioGroup, Radio } from '@mui/material';

import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';

import moment from 'moment';

import { openSnackbar } from '../../../store/slices/SnackbarSlice';

import { usePages } from '../../../hooks/usePages';

import { DialogDocumento } from '../../../dialogs/DialogDocumento';

import { Layout } from '../../../components/Layout';
import { InfoField } from '../../../components/InfoField';
import { BoxProcesoTerminado } from '../../../components/BoxProcesoTerminado';
import { BoxProcesoCancelado } from '../../../components/BoxProcesoCancelado';
import { BoxProcesoNoEncontrado } from '../../../components/BoxProcesoNoEncontrado';
import { CircularProgressIndicator } from '../../../components/CircularProgressIndicator';

import { TablePaginationActions } from '../../../helpers/TablePaginationActions';

import { TableTheadStyle, TablePaddingStyle } from '../../../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from '../../../styles/DialogStyle';

import { ObtenerMateria } from '../../../connections/catalogos/MateriaConnection';
import { ObtenerTipoTramites } from '../../../connections/catalogos/TipoTramiteConnection';
import { FinalizarListadoEntrega, GenerarListadoEntrega, DetalleListadoEntrega, DetalleListadoEntregaTabla } from '../../../connections/comun/ListadoEntregaConnection';

import { MateriaProps } from '../../../interfaces/catalogos/MateriaInterface';
import { TipoTramiteProps } from '../../../interfaces/catalogos/TipoTramiteInterface';
import { defaultDetalleListadoEntregaResponse, DetalleListadoEntregaResponse, ListadoEntregaRecepcionProps } from '../../../interfaces/comun/ListadoEntregaInterface';

type EnvioBuzonType = 'Todos' | 'Si' | 'No';

export const GenerarListadoEntregaPage = () => {

    const { Id } = useParams();

    const dispatch = useDispatch();

    const [open, setOpen] = useState( true );

    const [loading, setLoading] = useState( true );
    const [loadingSearch, setLoadingSearch] = useState( false );
    const [loadingFinalizar, setLoadingFinalizar] = useState( false );

    const [procesoTerminado, setProcesoTerminado] = useState( false );
    const [procesoCancelado, setProcesoCancelado] = useState( false );
    const [procesoNoEncontrado, setProcesoNoEncontrado] = useState( false );
    const [mensajeFinalizacion, setMensajeFinalizacion] = useState('');

    const [openDocument, setOpenDocument] = useState( false );
    const [openDialogConfirmacion, setOpenDialogConfirmacion] = useState( false );
    const [openDialogConfirmacionFinalizar, setOpenDialogConfirmacionFinalizar] = useState( false );

    const [documento, setDocumento] = useState<string>( '' );

    const [fecha, setFecha] = useState( '' );

    const [tipoTramite, setTipoTramite] = useState(0);
    const [tipoTramiteArray, setTipoTramiteArray] = useState<TipoTramiteProps[]>( [] );

    const [documentoFirmado, setDocumentoFirmado] = useState<string>( '' );
    const [filtroAplicado, setFiltroAplicado] = useState( false );

    const [materia, setMateria] = useState(0);
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );

    const [rows, setRows] = useState<ListadoEntregaRecepcionProps[]>( [] );

    const [rowsAll, setRowsAll] = useState( false );

    const [envioBuzon, setEnvioBuzon] = useState<EnvioBuzonType>( 'Todos' );
    
    const [listadoEntrega, setListadoEntrega] = useState<DetalleListadoEntregaResponse>( defaultDetalleListadoEntregaResponse );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 10 );

    const handleClearFiltro = () => {

        setFecha( '' );
        setMateria( 0 );
        setTipoTramite( 0 );

        setEnvioBuzon( 'Todos' );
        
        setFiltroAplicado( false );
        setRowsAll( false );
        resetPage();

    }

    const handleBuscar = async () => {

        setFiltroAplicado( true );
        setLoadingSearch( true );
        setLoading( true );
        setRows( [] );
        resetPage();

        const porBuzon = envioBuzon === 'Todos' ? 0 : envioBuzon === 'Si' ? 1 : 2;

        await DetalleListadoEntregaTabla({ idListadoEntrega: Id ?? '', idTipoTramite: tipoTramite, idMateria: materia, fecha, enviadoBuzon: porBuzon }).then( resp => {

            setTimeout(() => {

                setRows( resp );

                setLoadingSearch( false );
                setLoading( false );

            }, 700);

        });

    }

    const handleGenerarVisualizar = () => {

        if ( documentoFirmado ) {

            setDocumento( documentoFirmado );
            setOpenDocument( true );

        } 
        else {

            setOpenDialogConfirmacion( true );

        }

    }

    const handleGenerarListado = async () => {

        setLoadingFinalizar( true );

        await GenerarListadoEntrega({ idListadoEntrega: Id ?? '' , recepciones: rows }).then(resp => {

            setTimeout(() => {

                const { documento, success, message } = resp;

                if ( success ) {

                    setDocumentoFirmado( documento );
                    setDocumento( documento );

                    setOpenDocument( true );
                    setLoadingFinalizar( false );
                    setOpenDialogConfirmacion( false );
   
                } 
                else {
                             
                    dispatch( openSnackbar({ message: message, variant: 'error' }) );                    
                    setLoadingFinalizar( false );
                        
                }
                
            }, 700);

        });
    }

    const handleFinalizar = async () => {

        setLoadingFinalizar( true );

        await FinalizarListadoEntrega( Id ?? '' ).then( resp => {
            
            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    setLoadingFinalizar( false );
                    setOpenDialogConfirmacionFinalizar( false )
                    setProcesoTerminado( true );
                    
                    setMensajeFinalizacion( 'No se tienen actividades pendientes para este trámite' );

                } 
                else {

                    dispatch( openSnackbar({ message: message, variant: 'error' }) );
                    setLoadingFinalizar( false );

                }
                    
            }, 700);

        });

    }

    const handleSelectAll = ( value: boolean ) => {

        setRows( rows.map( elem => ({ ...elem, selected: value }) ) );
        setRowsAll( value );

    }

    const handleSelectRow = ( value: boolean, id: number ) => {

        setRows( rows.map(elem => 
            elem.idRecepcion === id ? { ...elem, selected: value } : elem
        ));

    }

    useEffect(() => {

        async function Obtener() {

            await ObtenerMateria().then( resp => {

                setMateriaArray( resp );

            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoTramites().then( resp => {

                setTipoTramiteArray( resp );

            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            setRows( [] );

            await DetalleListadoEntrega( Id ?? '' ).then(resp => {

                const { documento, idEstatus, asignadoMismoUsuario } = resp;

                setTimeout(() => {

                    setListadoEntrega( resp );

                    if ( idEstatus === 9 ) {
                        
                        setProcesoTerminado( true );                        
                        setMensajeFinalizacion( 'No se tienen actividades pendientes para este trámite' );

                    } 
                    else if ( idEstatus === 10 ) {

                        setProcesoCancelado( true );
                        
                    } 
                    else if ( !asignadoMismoUsuario && idEstatus === 11 ) {

                        setProcesoNoEncontrado( true );

                    }

                    setDocumentoFirmado( documento );
                    setOpen( false );

                }, 700);

            });

        }
        
        if( Id ){
            Obtener();
        }

    }, [ Id ])

    useEffect(() => {

        async function Obtener() {
            
            setLoading( true );
            setRows( [] );            

            await DetalleListadoEntregaTabla({ idListadoEntrega: Id ?? '', idTipoTramite: 0, idMateria: 0, fecha: '', enviadoBuzon: 0 }).then( resp => {

                setTimeout(() => {

                    setRows( resp );

                    setLoadingSearch( false );
                    setLoading( false );

                }, 700);

            });

        }

        if ( Id && !filtroAplicado ) {
            Obtener();
        }

    }, [ Id, filtroAplicado ])

    return (

        <Layout breadcrumbs={[{ text: 'Listado de entrega' }, { text: 'Generar listado de entrega' }]} backgroundPaper={( procesoTerminado || procesoCancelado || procesoNoEncontrado )}>
          
            {   
                open
                ?
                    <Box sx={{ textAlign: 'center', alignItems: 'center', minHeight: 580 }}>
                        <CircularProgressIndicator mt={30} />
                    </Box>
                :
                    ( procesoTerminado || procesoCancelado || procesoNoEncontrado )
                    ?
                        procesoNoEncontrado
                        ?
                            <BoxProcesoNoEncontrado />
                        :
                            procesoCancelado
                            ?
                                <BoxProcesoCancelado />
                            :
                                <BoxProcesoTerminado message={ mensajeFinalizacion } />
                    :
                        <>

                            <Grid container spacing={3} >

                                <Grid size={12}>

                                    <Card>

                                        <CardContent>

                                            <Grid container spacing={3}>                             
                                    
                                                <Grid size={{ md: 4, xs: 12 }}>

                                                    <InfoField
                                                        label="Número de seguimiento" 
                                                        value={ `GLE-${ listadoEntrega.idListadoEntrega }` }
                                                        fontSize={ 22 }
                                                    />    
                                                    
                                                </Grid>    

                                                <Grid size={{ md: 4, xs: 12 }}>

                                                    <InfoField
                                                        label="Fecha" 
                                                        value={ listadoEntrega.fecha ? moment( listadoEntrega.fecha ).format( 'DD-MM-YYYY hh:mm a' ) : '' }
                                                        fontSize={ 22 }
                                                    />    
                                                                    
                                                </Grid>   

                                            </Grid>    

                                        </CardContent>

                                    </Card>

                                </Grid>
                           
                                <Grid size={12}>

                                    <Grid container spacing={3} >

                                        <Grid size={{ md: 12, xs: 12 }}>

                                            <Card>

                                                <CardHeader
                                                    sx={{ backgroundColor: (theme) => theme.palette.primary.main }}
                                                    subheader={<Typography sx={{ fontWeight: '400', color: 'white' }}> Filtro(s) </Typography>}
                                                />

                                                <Divider />

                                                <CardContent sx={{ p: 3 }}>

                                                    <Grid container spacing={3}>

                                                        <Grid size={{ md: 4, xs: 12 }}>

                                                            <TextField
                                                                fullWidth
                                                                label='Fecha del trámite'
                                                                type='date'
                                                                name='fechaTramite'
                                                                disabled={ filtroAplicado || loading || !!documentoFirmado }
                                                                value={ fecha }
                                                                onChange={ e => setFecha( e.target.value ) }
                                                                slotProps={{
                                                                    input: {
                                                                        autoComplete: 'off'
                                                                    },
                                                                    inputLabel: {
                                                                        shrink: true,
                                                                    }
                                                                }}
                                                            />

                                                        </Grid>

                                                        <Grid size={{ md: 4, xs: 12 }}>

                                                            <FormControl fullWidth>

                                                                <InputLabel>Tipo de trámite</InputLabel>

                                                                <Select
                                                                    label='Tipo de trámite'
                                                                    disabled={ filtroAplicado || loading || !!documentoFirmado }
                                                                    value={ tipoTramite }
                                                                    onChange={ (e) => setTipoTramite( e.target.value ) }
                                                                >
                                                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>
                                                                    {
                                                                        tipoTramiteArray
                                                                        .map(({ idTipoTramite, descripcion }) => (
                                                                            <MenuItem key={idTipoTramite} value={idTipoTramite}>{ descripcion }</MenuItem>
                                                                        ))
                                                                    }
                                                                </Select>

                                                            </FormControl>

                                                        </Grid>

                                                        <Grid size={{ md: 4, xs: 12 }}>

                                                            <FormControl fullWidth>

                                                                <InputLabel>Materia</InputLabel>

                                                                <Select
                                                                    label='Materia'
                                                                    disabled={ filtroAplicado || loading || !!documentoFirmado }
                                                                    value={ materia }
                                                                    onChange={ (e) => setMateria( e.target.value ) }
                                                                >
                                                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>
                                                                    {
                                                                        materiaArray
                                                                        .map(({ idMateria, descripcion }) => (
                                                                            <MenuItem key={idMateria} value={idMateria}>{ descripcion }</MenuItem>
                                                                        ))
                                                                    }
                                                                </Select>

                                                            </FormControl>

                                                        </Grid>

                                                        <Grid size={{ md: 9, xs: 12 }}>

                                                            <FormControl>

                                                                <FormLabel>Mostrar trámites enviados por buzón electrónico</FormLabel>

                                                                <RadioGroup row >

                                                                    <FormControlLabel
                                                                        disabled={ filtroAplicado || loading || !!documentoFirmado }
                                                                        label={ 'Todos' }
                                                                        control={ <Radio checked={ envioBuzon === 'Todos' } onChange={ () => setEnvioBuzon( 'Todos' ) } />}
                                                                    />

                                                                    <FormControlLabel
                                                                        disabled={ filtroAplicado || loading || !!documentoFirmado }
                                                                        label={ 'Si' }
                                                                        control={ <Radio checked={ envioBuzon === 'Si' } onChange={ () => setEnvioBuzon( 'Si' ) } />}
                                                                    />
                                                            
                                                                    <FormControlLabel
                                                                        disabled={ filtroAplicado || loading || !!documentoFirmado }
                                                                        label={ 'No' }
                                                                        control={ <Radio checked={ envioBuzon === 'No' } onChange={ () => setEnvioBuzon( 'No' ) } />}
                                                                    />

                                                                </RadioGroup>

                                                            </FormControl>

                                                        </Grid>

                                                        <Grid size={{ md: 3, xs: 12 }}>

                                                            <Button
                                                                fullWidth
                                                                color={ filtroAplicado ? 'inherit' : 'primary' }
                                                                variant='contained'
                                                                loading={ loadingSearch }
                                                                disabled={ loading || documentoFirmado !== '' }
                                                                onClick={ filtroAplicado ? handleClearFiltro : handleBuscar }
                                                            >
                                                                { filtroAplicado ? 'Limpiar' : 'Buscar' }
                                                            </Button>

                                                        </Grid>

                                                    </Grid>

                                                </CardContent>

                                            </Card>

                                        </Grid>

                                        <Grid size={{ md: 8, xs: 12 }}></Grid>

                                        <Grid size={{ md: 4, xs: 12 }}>

                                            <Grid container spacing={3}>

                                                <Grid size={{ md: 8, xs: 12 }}>

                                                    <Button
                                                        fullWidth
                                                        color='secondary'
                                                        variant='outlined'
                                                        disabled={ documentoFirmado === '' && rows.filter( ({ selected }) => selected === true ).length === 0 }
                                                        onClick={ handleGenerarVisualizar }
                                                    >
                                                        { documentoFirmado !== '' ? 'Visualizar listado de entrega' : 'Generar listado de entrega' }
                                                    </Button>

                                                </Grid>

                                                <Grid size={{ md: 4, xs: 12 }}>

                                                    <Button
                                                        fullWidth
                                                        variant='contained'
                                                        disabled={ !documentoFirmado || loadingFinalizar }
                                                        onClick={ () => setOpenDialogConfirmacionFinalizar (true ) }
                                                    >
                                                        Finalizar
                                                    </Button>

                                                </Grid>

                                            </Grid>

                                        </Grid>

                                        <Grid size={{ md: 12, xs: 12 }}>

                                            <TableContainer sx={{ borderRadius: 3 }} component={Paper}>

                                                <Table sx={{ minWidth: 500 }}>

                                                    <TableHead sx={{ ...TableTheadStyle }}>

                                                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold' }}></TableCell>
                                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Referencia</TableCell>
                                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '20%', fontWeight: 'bold' }}>Tipo de trámite</TableCell>
                                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Escrito</TableCell>
                                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold', textAlign: 'center' }}>Acuse</TableCell>
                                                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '15%', fontWeight: 'bold' }}></TableCell>

                                                            {
                                                                !documentoFirmado
                                                                &&
                                                                    <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width: '10%', fontWeight: 'bold', textAlign: 'end' }}>
                                                                        
                                                                        <Tooltip title='Seleccionar todo'>

                                                                            <Checkbox
                                                                                checked={ rowsAll }
                                                                                onChange={ (e) => handleSelectAll( e.target.checked ) }
                                                                                sx={{ bgcolor: 'white', borderRadius: 2, ':hover': { bgcolor: 'white' } }}
                                                                            />

                                                                        </Tooltip>

                                                                    </TableCell>
                                                            }

                                                        </TableRow>

                                                    </TableHead>

                                                    <TableBody>

                                                        {
                                                            (
                                                                rowsPerPage > 0
                                                                ?
                                                                    rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                :
                                                                    rows
                                                            )               
                                                            .map(({ idRecepcion, numeroSeguimiento, fecha, referencia, materia, noReferencia, tipoTramite, subTipoTramite, folioBuzonElectronico, acuse, escrito, selected }, index) => (

                                                                <TableRow key={index} >

                                                                    <TableCell>

                                                                        <Typography variant='subtitle1'>
                                                                            <strong>{ numeroSeguimiento }</strong>
                                                                        </Typography>

                                                                        { fecha && <Typography variant='subtitle1' fontSize={14}>{ moment( fecha ).format( 'DD-MM-YYYY a' ) } </Typography> }

                                                                    </TableCell>

                                                                    <TableCell sx={{ textAlign: 'center' }}>

                                                                        {
                                                                            ( noReferencia && referencia )
                                                                            ?
                                                                                <>
                                                                                    <Typography variant='subtitle1'><strong>{referencia}</strong></Typography>
                                                                                    <Typography variant='subtitle2' fontWeight={'normal'} mt={1}>{ noReferencia }</Typography>

                                                                                    <Typography variant='subtitle2' fontWeight={'normal'} mt={1}>({ materia })</Typography>
                                                                                </>
                                                                            :
                                                                                <>
                                                                                    <Typography variant='subtitle1'><strong>{ referencia }</strong></Typography>

                                                                                    {
                                                                                        referencia && <Typography variant='subtitle2' fontWeight={'normal'} mt={1}>({ materia })</Typography>
                                                                                    }

                                                                                </>
                                                                        }

                                                                    </TableCell>

                                                                    <TableCell>

                                                                        <Typography variant='subtitle1'>
                                                                            <strong>{ tipoTramite }</strong>
                                                                        </Typography>

                                                                        {
                                                                            subTipoTramite && <Typography variant='subtitle1' fontSize={14}>{ subTipoTramite } </Typography>
                                                                        }

                                                                    </TableCell>

                                                                    <TableCell sx={{ textAlign: 'center' }} >

                                                                        {
                                                                            escrito
                                                                            &&
                                                                                <Button
                                                                                    fullWidth
                                                                                    variant='contained'
                                                                                    sx={{ textTransform: 'none' }}
                                                                                    onClick={() => { setOpenDocument( true ); setDocumento( escrito ); }}
                                                                                >
                                                                                    Ver escrito
                                                                                </Button>
                                                                        }

                                                                    </TableCell>

                                                                    <TableCell sx={{ textAlign: 'center' }} >

                                                                        {
                                                                            acuse
                                                                            &&
                                                                                <Button
                                                                                    fullWidth
                                                                                    variant='contained'
                                                                                    sx={{ textTransform: 'none' }}
                                                                                    onClick={() => { setOpenDocument( true ); setDocumento( acuse ); }}
                                                                                >
                                                                                    Ver acuse
                                                                                </Button>
                                                                        }

                                                                    </TableCell>

                                                                    <TableCell>

                                                                        {
                                                                            folioBuzonElectronico
                                                                            &&
                                                                                <Chip
                                                                                    variant='outlined'
                                                                                    color='secondary'
                                                                                    sx={{ p: 2 }}
                                                                                    icon={ <ForwardToInboxIcon fontSize='small' /> }
                                                                                    label={
                                                                                        <Typography variant='button' fontWeight={'600'} sx={{ ml: 1 }}>
                                                                                            { folioBuzonElectronico }
                                                                                        </Typography>
                                                                                    }
                                                                                />
                                                                        }

                                                                    </TableCell>

                                                                    {
                                                                        !documentoFirmado
                                                                        &&
                                                                            <TableCell sx={{ textAlign: 'end' }}>

                                                                                <Checkbox
                                                                                    checked={ selected }
                                                                                    onChange={ ( e ) => handleSelectRow( e.target.checked, idRecepcion ) }
                                                                                />

                                                                            </TableCell>
                                                                    }

                                                                </TableRow>

                                                            ))
                                                        }

                                                        {
                                                            ( rows.length === 0 && !loading )
                                                            ?
                                                                <TableRow style={{ height: 100 }}>

                                                                    <TableCell colSpan={7} align='center'>

                                                                        <Typography variant='caption' color='secondary'> No se encontraron resultados </Typography>

                                                                    </TableCell>

                                                                </TableRow>
                                                            :
                                                                loading
                                                                &&
                                                                    <TableRow style={{ height: 100 }}>

                                                                        <TableCell colSpan={7} align='center'>

                                                                            <CircularProgress size={26} />

                                                                        </TableCell>

                                                                    </TableRow>
                                                        }

                                                    </TableBody>

                                                    <TableFooter>

                                                        <TableRow>

                                                            <TableCell colSpan={2}>
                                                                <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> Total de trámites: { rows.length } </Typography>
                                                            </TableCell>

                                                            <TablePagination
                                                                rowsPerPageOptions={[5, 10, 15, 20, 50, 100]}
                                                                colSpan={10}
                                                                count={ rows.length }
                                                                rowsPerPage={ rowsPerPage }
                                                                page={ page}
                                                                onPageChange={ handleChangePage }
                                                                onRowsPerPageChange={ handleChangeRowsPerPage }
                                                                ActionsComponent={ TablePaginationActions }

                                                                labelRowsPerPage='Filas por página'
                                                                labelDisplayedRows={
                                                                    ({ from, to, count }) => {
                                                                        return '' + from + '-' + to + ' de ' + count
                                                                    }
                                                                }
                                                            />

                                                        </TableRow>

                                                    </TableFooter>

                                                </Table>

                                            </TableContainer>

                                        </Grid>

                                    </Grid>

                                </Grid>

                            </Grid>

                            <DialogDocumento
                                documento={ documento }
                                openDialog={ openDocument }
                                handleCloseDialog={ () => setOpenDocument( false ) }
                            />                            
                  
                            <Dialog
                                fullWidth
                                maxWidth='xs'
                                open={ openDialogConfirmacionFinalizar }
                                onClose={() => { }}
                            >

                                <DialogTitle>
                                    Confirmación
                                </DialogTitle>

                                <DialogContent sx={ DialogContentStyle }>

                                    <DialogContentText>
                                        ¿Desea finalizar el listado de entrega?
                                    </DialogContentText>

                                </DialogContent>

                                <DialogActions sx={ DialogActionsStyle }>
                                    <Button color='secondary' disabled={ loadingFinalizar } onClick={ () => setOpenDialogConfirmacionFinalizar( false ) }> Cancelar </Button>
                                    <Button loading={ loadingFinalizar } onClick={ handleFinalizar } variant='contained' > Aceptar </Button>
                                </DialogActions>
                            </Dialog>

                            <Dialog
                                fullWidth
                                maxWidth='xs'
                                open={ openDialogConfirmacion }
                                onClose={ () => {} }
                            >

                                <DialogTitle>
                                    Confirmación
                                </DialogTitle>

                                <DialogContent sx={ DialogContentStyle }>

                                    <DialogContentText>
                                        ¿Desea generar el listado de entrega?
                                    </DialogContentText>

                                </DialogContent>

                                <DialogActions sx={ DialogActionsStyle }>

                                    <Button color='secondary' disabled={ loadingFinalizar } onClick={ () => setOpenDialogConfirmacion( false ) }> Cancelar </Button>
                                    <Button loading={ loadingFinalizar } onClick={ handleGenerarListado } variant='contained' > Aceptar </Button>

                                </DialogActions>

                            </Dialog>

                        </>
            }

        </Layout >
    )
}
